<template>
  <div class="about">
    <banner />
    <div class="section project-case">
      <div class="column">
        <h2>工程案例</h2>
      </div>
      <el-row :gutter="20">
        <el-col
          :span="isPc ? 8 : 24"
          v-for="item in cases"
          :key="item.comRelatedId"
        >
          <div
            class="project-info little_hand"
            @click="toCaseDetails(item.comRelatedId, item.url)"
          >
            <img :src="item.image" />
            <div class="title items-end">
              <h4 class="items-end">{{ item.title }}</h4>
            </div>
            <div class="hover-info flex-col">
              <h5 class="items-end">{{ item.comRelatedDescrip }}</h5>
              <svg-icon icon-class="direction"></svg-icon>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="justify-center">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          @current-change="changeSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../common/banner.vue";
import { getRelatedByCase } from "@/assets/api/about.js";

import { mapState } from "vuex";

export default {
  name: "cases",
  components: {
    banner,
  },
  data() {
    return {
      cases: [],
      total: 0,
      pageNum: 1,
      pageSize: 6,
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getRelatedByCase({
        orderByColumn: "orderNum",
        isAsc: "desc",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        // console.log(res.data);
        this.total = res.data.data.total;
        this.cases = res.data.data.rows.map((item) => {
          item.image = !/^http/.test(item.image)
            ? this.$imgUrl + item.image
            : item.image;
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    toCaseDetails(comRelatedId, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/case-details/${comRelatedId}`,
        });
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.section {
  width: 1000px;
  margin: auto;
  position: relative;
}
.column {
  padding-top: 60px;
  margin-bottom: 24px;

  h2 {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #2c2c2e;
    line-height: 42px;
  }
}

.project-case {
  border-bottom: 1px solid #e5e5ea;
padding-bottom: 80px;
  .project-info {
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
    img {
      width: 100%;
      height: 420px;
      object-fit: cover;
    }
    .title {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 20px;

      height: 210px;
      background-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.64) 100%
      );
      border-bottom: 8px solid #005bac;
    }
    h4 {
      font-family: MicrosoftYaHei-Bold;
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 36px;
      height: 72px;
      font-weight: 700;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .hover-info {
      position: absolute;
      transition: all 0.5s;
      width: 100%;
      // height: 160px;
      background: #005bac;
      padding: 20px;
      color: #ffffff;
      h5 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 36px;
        font-weight: 700;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .svg-icon {
        width: 48px;
        height: 24px;
        margin-top: 24px;
      }
    }
  }
  .project-info:hover {
    .hover-info {
      bottom: 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .section {
    width: 100%;
    padding: 0 20px;
  }
  .column {
    padding-top: 60px;
    margin-bottom: 16px;

    h2 {
      font-size: 24px;
      line-height: 31px;
    }
  }
  .project-case {
    padding-bottom: 44px;
    border-bottom: none;
    .project-info {
      margin-bottom: 16px;
      img {
        height: 456px;
      }
      h4 {
        height: 228px;
        font-size: 20px;
        line-height: 30px;
      }
      .hover-info {
        position: absolute;
        transition: all 0.5s;
        width: 100%;
        // height: 160px;
        background: #005bac;
        padding: 20px;
        color: #ffffff;
        h5 {
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 36px;
          font-weight: 700;
        }
        .svg-icon {
          width: 48px;
          height: 24px;
          margin-top: 24px;
        }
      }
    }
    .project-info:hover {
      .hover-info {
        bottom: 0;
      }
    }
  }
}
</style>
<style>
.el-pager li {
  font-size: 16px;
  padding: 0 8px;
  height: auto;
}
.el-pager li:hover {
  color: #005bac;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #005bac;
}
</style>


// WEBPACK FOOTER //
// src/views/cases/index.vue